var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-page',{attrs:{"name":"not-found","centered":""}},[_c('h1',[_vm._v("Page introuvable!")]),_c('div',{staticClass:"text-center"},[_c('b-button',{attrs:{"to":"/"}},[_vm._v("Retour à l'accueil")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }